import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/content';
const links = [{
  label: 'Términos y Condiciones',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}, {
  label: 'Contacto',
  href: `mailto:${SUPPORT_EMAIL}`
}];
export function Footer() {
  return <footer className="bg-canvas" data-id="element-69" data-mp="36oy0j8d4dv1j">
      <div className="mx-auto max-w-2xl px-4 py-6 pb-20 text-center sm:pb-6" data-id="element-70" data-mp="36pzaf9iegbho">
        <p className="text-xs text-muted" data-id="element-71" data-mp="3ug3efhzi2d97">© 2026 — Todos los Derechos Reservados.</p>
        <p className="mt-2 text-[0.68rem] leading-snug text-muted/80" data-id="element-72" data-mp="398xsbsbb070">
          {PRODUCT_NAME}™ es un producto educativo. No sustituye formación
          profesional, práctica supervisada, manuales de fabricantes, normativa
          eléctrica y de seguridad aplicable, licencias, certificaciones,
          permisos ni el criterio de un profesional habilitado. Los cercos
          eléctricos pueden implicar riesgos graves cuando se instalan,
          configuran o manipulan incorrectamente. Toda instalación y práctica
          debe realizarse sobre sistemas propios o expresamente autorizados,
          siguiendo las instrucciones oficiales del fabricante y la normativa
          vigente aplicable.
        </p>
        <p className="mt-2 text-xs text-muted" data-id="element-73" data-mp="3v8hqs5s2uyrj">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-medium text-accent transition-colors duration-150 ease-soft hover:text-accent-strong" data-id="element-74" data-mp="3q83rpd8gez5n">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-2" data-id="element-75" data-mp="33e69a7d4qs7">
          <ul className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-muted" data-id="element-76" data-mp="htczqznz3e1c">
            {links.map((link, i) => <li key={link.label} className="flex items-center gap-2" data-id="element-77" data-mp="cuikg7p7s7lz" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" data-id="element-78" data-mp="qub8twd9qbqs">•</span>}
                <a href={link.href} className="whitespace-nowrap transition-colors duration-150 ease-soft hover:text-accent" data-id="element-79" data-mp="mrwrxht5tm25">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
    </footer>;
}